import type { Plugin, SelectionProps } from '@gitbook/slate-react';

import { RealtimeSelectionFocus } from './RealtimeSelectionFocus';
import { RealtimeSelectionRange } from './RealtimeSelectionRange';
import { SELECTION_FOCUS, SELECTION_RANGE } from './types';

export const plugin: Plugin = {
    renderSelection,
};

/**
 * Rendering method for selections.
 */
function renderSelection(props: SelectionProps) {
    const { type } = props;

    switch (type) {
        case SELECTION_FOCUS:
            return <RealtimeSelectionFocus {...props} />;
        case SELECTION_RANGE:
            return <RealtimeSelectionRange {...props} />;
    }
}
